export const setBestGuessAddress = async (): Promise<void> => {
  try {
    await fetch('/api/cart/best-guess-address', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      cache: 'no-store',
    });
  } catch (_) {
    console.debug('no best guess', _);
  }
};
